'use strict';

var recruitingAnalyticsCtrl = function ($scope, railApi, $filter, $stateParams, $rootScope, $window, $timeout) {
    var palette = ['#3478f6', '#7857e8', '#35b779', '#f6a623', '#24b7c7', '#8c9aaf'];
    var funnelPalette = ['#3478f6', '#7857e8', '#35b779', '#f6a623', '#24b7c7'];
    // A fixed threshold keeps warnings comparable when users change the report period.
    var slowTimeToHireDays = 60;
    // Larger organization-wide ranges can exceed the reporting service's processing capacity.
    var maxReportRangeMonths = 6;
    var routeJobId = parseInt($stateParams.job_id, 10);
    var employeeId = $rootScope.hgUserData && $rootScope.hgUserData.id || 'default';
    var tenantDomain = $rootScope.domain || 'default';
    var isJobAnalytics = !isNaN(routeJobId) && routeJobId > 0;
    var collapsedReportNames = isJobAnalytics ? ['activity'] : ['activity', 'sourceEffectiveness', 'jobPerformance'];
    var collapsedReportsPreferenceKey = isJobAnalytics ?
        'startdate.jobAnalytics.collapsed.v1.' + employeeId + '.' + routeJobId :
        'startdate.recruitingAnalytics.collapsed.v2.' + employeeId;
    var legacyCollapsedReportsPreferenceKey = 'startdate.recruitingAnalytics.collapsed.v1.' + tenantDomain + '.' + employeeId;
    var journeyChartPlaceholder;
    var journeyTooltip;
    var journeyTooltipPointKey;
    var loadGeneration = 0;

    $scope.isJobAnalytics = isJobAnalytics;
    $scope.jobId = $scope.isJobAnalytics ? routeJobId : null;

    $scope.filters = {
        startDate: moment().subtract(29, 'days').startOf('day'),
        endDate: moment().endOf('day'),
        jobScope: 'public'
    };

    $scope.analytics = {};
    $scope.kpis = {};
    $scope.collapsedReports = {
        activity: false,
        sourceEffectiveness: false,
        jobPerformance: false
    };
    $scope.jobPerformanceSort = { field: 'applicants', predicate: 'applicants', reverse: true };
    $scope.selectedAgingBucket = null;
    $scope.showAllOpenJobs = false;
    $scope.loading = false;
    $scope.loadError = false;
    $scope.invalidDateRange = false;
    $scope.reportStates = {};

    function storedPreference(storage, key) {
        if (!key) {
            return null;
        }

        try {
            return storage && storage.getItem(key);
        } catch (error) {
            return null;
        }
    }

    function loadCollapsedReportPreferences() {
        var savedPreferences;
        var savedValue;

        savedValue = storedPreference($window.localStorage, collapsedReportsPreferenceKey) ||
            storedPreference($window.sessionStorage, collapsedReportsPreferenceKey);
        if (!$scope.isJobAnalytics) {
            savedValue = savedValue ||
                storedPreference($window.localStorage, legacyCollapsedReportsPreferenceKey) ||
                storedPreference($window.sessionStorage, legacyCollapsedReportsPreferenceKey);
        }

        try {
            savedPreferences = JSON.parse(savedValue);
            _.each(collapsedReportNames, function (report) {
                if (savedPreferences && typeof savedPreferences[report] === 'boolean') {
                    $scope.collapsedReports[report] = savedPreferences[report];
                }
            });
        } catch (error) {
            // Keep reports expanded when storage is unavailable or contains invalid data.
        }
    }

    function saveCollapsedReportPreferences() {
        var savedPreferences;

        savedPreferences = JSON.stringify({
            activity: $scope.collapsedReports.activity,
            sourceEffectiveness: $scope.collapsedReports.sourceEffectiveness,
            jobPerformance: $scope.collapsedReports.jobPerformance
        });

        try {
            $window.localStorage.setItem(collapsedReportsPreferenceKey, savedPreferences);
        } catch (error) {
            // Session storage below still preserves the state across a refresh.
        }

        try {
            $window.sessionStorage.setItem(collapsedReportsPreferenceKey, savedPreferences);
        } catch (error) {
            // Collapse controls still work for the current page when storage is unavailable.
        }
    }

    loadCollapsedReportPreferences();

    function removeJourneyTooltip() {
        if (journeyTooltip) {
            journeyTooltip.remove();
            journeyTooltip = null;
        }
        journeyTooltipPointKey = null;
    }

    // This build does not load Flot's tooltip plugin, so bind the activity tooltip through the plot callback.
    $scope.journeyChartReady = function (plot) {
        if (journeyChartPlaceholder) {
            journeyChartPlaceholder.off('.recruitingAnalyticsTooltip');
        }

        journeyChartPlaceholder = plot.getPlaceholder();
        journeyChartPlaceholder.on('plothover.recruitingAnalyticsTooltip', function (event, position, item) {
            var pointKey = item && item.seriesIndex + ':' + item.dataIndex;

            if (pointKey === journeyTooltipPointKey) {
                return;
            }

            removeJourneyTooltip();
            if (!item) {
                return;
            }

            journeyTooltipPointKey = pointKey;
            journeyTooltip = angular.element('<div id="flotTip" role="tooltip"></div>');
            journeyTooltip.text(item.series.label + ': ' + $filter('number')(item.datapoint[1], 0));
            journeyTooltip.css({
                left: item.pageX + 12,
                position: 'absolute',
                top: item.pageY - 32
            });
            angular.element($window.document.body).append(journeyTooltip);
        });
        journeyChartPlaceholder.on('mouseleave.recruitingAnalyticsTooltip', removeJourneyTooltip);
    };

    $scope.$on('$destroy', function () {
        if (journeyChartPlaceholder) {
            journeyChartPlaceholder.off('.recruitingAnalyticsTooltip');
        }
        removeJourneyTooltip();
    });

    $scope.journeyChartOptions = {
        series: {
            lines: { show: true, lineWidth: 3 },
            points: { show: true, radius: 2 }
        },
        grid: { borderWidth: 0, hoverable: true },
        legend: { position: 'nw' },
        xaxis: { mode: 'time', tickLength: 0 },
        yaxis: { min: 0, tickDecimals: 0 }
    };

    $scope.pieChartOptions = {
        series: {
            pie: {
                show: true,
                innerRadius: 0.58,
                radius: 0.92,
                label: { show: false }
            }
        },
        grid: { hoverable: true },
        legend: { show: false }
    };

    $scope.jobsChartOptions = {
        series: { bars: { show: true, barWidth: 18 * 60 * 60 * 1000, align: 'center' } },
        colors: ['#3478f6'],
        grid: { borderWidth: 0, hoverable: true },
        legend: { show: false },
        xaxis: { mode: 'time', tickLength: 0 },
        yaxis: { min: 0, tickDecimals: 0 }
    };

    function numberValue(value) {
        var parsed = Number(value);
        return isNaN(parsed) ? 0 : parsed;
    }

    function translate(key) {
        return $filter('hgTranslate')(key);
    }

    function sumSeries(series) {
        return _.reduce((series && series.data) || [], function (total, point) {
            return total + numberValue(point[1]);
        }, 0);
    }

    function findSeries(series, label) {
        return _.find(series || [], function (item) {
            return item.label === label;
        });
    }

    function displayLabel(label) {
        if (_.isObject(label)) {
            return label[$scope.currentLang] || label.en || _.values(label)[0];
        }
        return label || '';
    }

    function prepareSources(sources) {
        var grouped = {};

        _.each(sources || [], function (source) {
            var label = displayLabel(source.label) || translate('RecruitingAnalytics.Other');
            grouped[label] = numberValue(grouped[label]) +
                numberValue(source.data && source.data[0] && source.data[0][1]);
        });

        var sorted = _.chain(grouped)
            .map(function (value, label) {
                return { label: label, value: value };
            })
            .filter(function (source) { return source.value > 0; })
            .sortBy(function (source) { return -source.value; })
            .value();
        var total = _.reduce(sorted, function (sum, source) {
            return sum + source.value;
        }, 0);
        var visible = sorted.length > 5 ? sorted.slice(0, 4) : sorted.slice(0);
        var remaining = _.reduce(sorted.length > 5 ? sorted.slice(4) : [], function (sum, source) {
            return sum + source.value;
        }, 0);

        if (remaining > 0) {
            var otherLabel = translate('RecruitingAnalytics.Other');
            var existingOther = _.find(visible, function (source) {
                return source.label === otherLabel;
            });

            if (existingOther) {
                existingOther.value += remaining;
            } else {
                visible.push({ label: otherLabel, value: remaining });
            }
        }

        return {
            total: total,
            items: _.map(visible, function (source, index) {
                source.color = palette[index % palette.length];
                source.percent = total ? Math.round(source.value / total * 100) : 0;
                source.data = [[1, source.value]];
                return source;
            })
        };
    }

    function prepareSourceEffectiveness(records) {
        var grouped = {};

        _.each(records || [], function (record) {
            var label = displayLabel(record.label) || translate('RecruitingAnalytics.Other');
            var row = grouped[label] || {
                label: label,
                applications: 0,
                interviews: 0,
                hires: 0
            };

            row.applications += numberValue(record.applications);
            row.interviews += numberValue(record.interviews);
            row.hires += numberValue(record.hires);
            grouped[label] = row;
        });

        var rows = _.chain(grouped)
            .values()
            .filter(function (row) { return row.applications > 0; })
            .map(function (row) {
                row.hireRate = Math.round(row.hires / row.applications * 1000) / 10;
                return row;
            })
            .sortBy(function (row) { return -row.applications; })
            .value();
        var bestRate = _.max(_.pluck(rows, 'hireRate')) || 0;

        return _.map(rows, function (row) {
            row.isBest = bestRate > 0 && row.hireRate === bestRate;
            return row;
        });
    }

    function prepareJobPerformance(records) {
        return _.map(records || [], function (record) {
            var averageDays = record.average_time_to_hire;

            return {
                jobId: numberValue(record.job_id),
                name: displayLabel(record.label) || ('#' + record.job_id),
                applicants: numberValue(record.applicants),
                hires: numberValue(record.hires),
                averageTimeToHire: averageDays === null || averageDays === undefined ? null : numberValue(averageDays),
                isSlow: averageDays !== null && averageDays !== undefined && numberValue(averageDays) > slowTimeToHireDays
            };
        });
    }

    function prepareOpenJobAging(records) {
        var definitions = [
            { key: '0-15', labelKey: 'RecruitingAnalytics.Aging0To15', min: 0, max: 15, color: '#3478f6' },
            { key: '16-30', labelKey: 'RecruitingAnalytics.Aging16To30', min: 16, max: 30, color: '#24b7c7' },
            { key: '31-60', labelKey: 'RecruitingAnalytics.Aging31To60', min: 31, max: 60, color: '#35b779' },
            { key: '61-90', labelKey: 'RecruitingAnalytics.Aging61To90', min: 61, max: 90, color: '#f6a623' },
            { key: '91+', labelKey: 'RecruitingAnalytics.Aging91Plus', min: 91, max: null, color: '#e45b4f' }
        ];
        var jobs = _.chain(records || [])
            .map(function (record) {
                return {
                    jobId: numberValue(record.job_id),
                    name: displayLabel(record.label) || ('#' + record.job_id),
                    openedAt: record.opened_at,
                    ageDays: numberValue(record.age_days)
                };
            })
            .sortBy(function (job) { return -job.ageDays; })
            .value();
        var buckets = _.map(definitions, function (definition) {
            var bucketJobs = _.filter(jobs, function (job) {
                return job.ageDays >= definition.min &&
                    (definition.max === null || job.ageDays <= definition.max);
            });

            return {
                key: definition.key,
                label: translate(definition.labelKey),
                color: definition.color,
                jobs: bucketJobs,
                count: bucketJobs.length
            };
        });
        var largestBucket = _.max(_.pluck(buckets, 'count')) || 0;

        _.each(buckets, function (bucket) {
            bucket.percent = largestBucket ? Math.round(bucket.count / largestBucket * 100) : 0;
        });

        return {
            jobs: jobs,
            oldestJobs: jobs.slice(0, 3),
            buckets: buckets
        };
    }

    function prepareStages(totals) {
        var stages = _.chain(totals || [])
            .map(function (stage) {
                return { label: stage[0], value: numberValue(stage[1]) };
            })
            .filter(function (stage) { return stage.value > 0; })
            .sortBy(function (stage) { return -stage.value; })
            .value();
        var maxValue = stages.length ? stages[0].value : 0;

        return _.map(stages.slice(0, 8), function (stage, index) {
            stage.color = palette[index % palette.length];
            stage.percent = maxValue ? Math.max(3, Math.round(stage.value / maxValue * 100)) : 0;
            return stage;
        });
    }

    function median(values) {
        var sorted = values.slice().sort(function (left, right) { return left - right; });
        var middle = Math.floor(sorted.length / 2);

        if (!sorted.length) {
            return 0;
        }
        return sorted.length % 2 ? sorted[middle] : (sorted[middle - 1] + sorted[middle]) / 2;
    }

    function prepareStageDurations(records) {
        var durations = _.chain(records || [])
            .map(function (record) {
                return {
                    label: displayLabel(record.label),
                    averageDays: numberValue(record.average_days),
                    observations: numberValue(record.observations)
                };
            })
            .filter(function (stage) {
                return stage.label && stage.observations > 0;
            })
            .value();
        var maxDays = _.max(_.pluck(durations, 'averageDays')) || 0;
        var benchmark = median(_.pluck(durations, 'averageDays'));
        var bottleneckThreshold = durations.length >= 3 && benchmark > 0 ? benchmark * 1.5 : Infinity;

        return _.map(durations, function (stage) {
            stage.percent = maxDays ? Math.max(2, Math.round(stage.averageDays / maxDays * 100)) : 0;
            stage.isBottleneck = stage.averageDays > benchmark && stage.averageDays >= bottleneckThreshold;
            return stage;
        });
    }

    function funnelStageType(stage) {
        var stageType = String(stage.stageType || '').toLowerCase();
        var stageName = String(stage.classificationName || stage.label || '').toLowerCase();

        if (stageType === 'rejected' || /reject|declin|withdraw|regret|disqual|not selected/.test(stageName)) {
            return 'rejected';
        }
        if (stageType === 'hired' || /hir(ed|e)/.test(stageName)) {
            return 'hired';
        }
        if (/offer/.test(stageName)) {
            return 'offered';
        }
        if (/interview/.test(stageName)) {
            return 'interviewed';
        }
        if (stageType === 'new' || /^new\b|appl/.test(stageName)) {
            return 'new';
        }
        return 'screened';
    }

    function prepareHiringFunnel(stages, appliedTotal) {
        var buckets = { screened: 0, interviewed: 0, offered: 0, hired: 0 };
        var stageTotal = 0;

        _.each(stages || [], function (stage) {
            var normalized = _.isArray(stage) ? {
                label: stage[0],
                classificationName: stage[0],
                value: numberValue(stage[1])
            } : stage;
            var value = numberValue(normalized.value);
            var type = funnelStageType(normalized);

            stageTotal += value;
            if (buckets.hasOwnProperty(type)) {
                buckets[type] += value;
            }
        });

        var applied = numberValue(appliedTotal);
        if (!applied && stageTotal) {
            applied = stageTotal;
        }
        if (!applied) {
            return [];
        }

        // These are cumulative current-pipeline levels. A candidate in a later
        // level also contributes to every earlier level in the funnel.
        var screened = Math.min(applied, buckets.screened + buckets.interviewed + buckets.offered + buckets.hired);
        var interviewed = Math.min(screened, buckets.interviewed + buckets.offered + buckets.hired);
        var offered = Math.min(interviewed, buckets.offered + buckets.hired);
        var hired = Math.min(offered, buckets.hired);
        var values = [applied, screened, interviewed, offered, hired];
        var labels = [
            'RecruitingAnalytics.FunnelApplied',
            'RecruitingAnalytics.FunnelScreened',
            'RecruitingAnalytics.FunnelInterviewed',
            'RecruitingAnalytics.FunnelOffered',
            'RecruitingAnalytics.FunnelHired'
        ];
        var widths = [100, 84, 68, 52, 36];

        return _.map(values, function (value, index) {
            var previousValue = index ? values[index - 1] : 0;
            return {
                label: translate(labels[index]),
                value: value,
                percent: index ? (previousValue ? Math.round(value / previousValue * 100) : 0) : null,
                width: widths[index],
                color: funnelPalette[index]
            };
        });
    }

    function prepareCandidateProgression(report) {
        var applied = numberValue(report && report.applied);
        var rows = [{
            label: translate('RecruitingAnalytics.FunnelApplied'),
            value: applied
        }];

        _.each((report && report.stages) || [], function (stage) {
            rows.push({
                label: displayLabel(stage.label),
                value: numberValue(stage.candidates)
            });
        });

        if (!applied && rows.length === 1) {
            return [];
        }

        var maxValue = _.max(_.pluck(rows, 'value')) || 0;
        return _.map(rows, function (row, index) {
            var previousValue = index ? rows[index - 1].value : 0;

            row.percent = maxValue && row.value ? Math.max(2, Math.round(row.value / maxValue * 100)) : 0;
            row.conversion = index && previousValue ? Math.round(row.value / previousValue * 1000) / 10 : null;
            row.color = palette[index % palette.length];
            return row;
        });
    }

    function prepareJourneySteps(series) {
        var definitions = [
            { apiLabel: 'Info', labelKey: 'RecruitingAnalytics.CareerPageViews' },
            {
                apiLabel: 'Apply',
                labelKey: $scope.isJobAnalytics ?
                    'RecruitingAnalytics.ApplicationPageVisits' : 'RecruitingAnalytics.ApplicationStarts'
            },
            { apiLabel: 'Apply Resume', labelKey: 'RecruitingAnalytics.ResumeStepViews' },
            { apiLabel: 'Apply Form', labelKey: 'RecruitingAnalytics.FormStepViews' },
            {
                apiLabel: 'Success',
                labelKey: $scope.isJobAnalytics ?
                    'RecruitingAnalytics.CompletionPageViews' : 'RecruitingAnalytics.CompletedApplications'
            }
        ];
        var values = _.map(definitions, function (definition) {
            definition.value = sumSeries(findSeries(series, definition.apiLabel));
            return definition;
        });
        var maxValue = _.max(_.pluck(values, 'value')) || 0;

        return _.map(values, function (step, index) {
            step.color = palette[index % palette.length];
            step.percent = maxValue ? Math.max(3, Math.round(step.value / maxValue * 100)) : 0;
            return step;
        });
    }

    function prepareJobViews(views) {
        var info = findSeries(views, 'Info');
        var apply = findSeries(views, 'Apply');
        var success = findSeries(views, 'Success');

        $scope.analytics.journey = _.compact([
            info && _.extend({}, info, { label: translate('RecruitingAnalytics.CareerPageViews'), color: palette[0] }),
            success && _.extend({}, success, {
                label: translate($scope.isJobAnalytics ?
                    'RecruitingAnalytics.CompletionPageViews' : 'RecruitingAnalytics.CompletedApplications'),
                color: palette[2]
            })
        ]);
        $scope.analytics.journeySteps = prepareJourneySteps(views);

        $scope.kpis.careerViews = sumSeries(info);
        $scope.kpis.applicationStarts = sumSeries(apply);
        $scope.kpis.completionPageViews = sumSeries(success);
        if (!$scope.isJobAnalytics) {
            $scope.kpis.completedApplications = $scope.kpis.completionPageViews;
            $scope.kpis.completionRate = $scope.kpis.applicationStarts ?
                Math.round($scope.kpis.completedApplications / $scope.kpis.applicationStarts * 100) : 0;
        }
    }

    function prepareCandidateSources(sources) {
        var preparedSources = prepareSources(sources);

        $scope.analytics.sources = preparedSources.items;
        $scope.analytics.sourceTotal = preparedSources.total;
    }

    function prepareJobsPosted(jobsPosted) {
        $scope.analytics.jobsPosted = jobsPosted;
        $scope.kpis.jobsPublished = sumSeries(jobsPosted[0]);
    }

    function prepareApplicantStages(stages) {
        $scope.analytics.stages = prepareStages(stages);
        $scope.kpis.currentCandidates = _.reduce(stages, function (total, stage) {
            return total + numberValue(stage[1]);
        }, 0);
        $scope.analytics.funnel = prepareHiringFunnel(stages, $scope.kpis.currentCandidates);
    }

    function prepareJob(job) {
        var stageTotals = _.map(job.workloads || [], function (workload) {
            return [displayLabel(workload.stage && workload.stage.name), numberValue(workload.applicants_count)];
        });
        var jobStartDate = moment(job.start_date).startOf('day');

        $scope.job = job;
        $scope.jobName = displayLabel(job.name);
        $scope.analytics.stages = prepareStages(stageTotals);
        $scope.kpis.currentCandidates = numberValue(job.applicants_count);
        $scope.kpis.jobAge = jobStartDate.isValid() ?
            Math.max(0, moment().startOf('day').diff(jobStartDate, 'days')) : 0;
    }

    function prepareTimeToHire(records) {
        var validRecords = _.filter(records || [], function (record) {
            var days = Number(record.time_to_hire);
            return record.time_to_hire !== null && record.time_to_hire !== '' && isFinite(days) && days >= 0;
        });
        var allHireDays = _.reduce(validRecords, function (total, record) {
            return total + Number(record.time_to_hire);
        }, 0);

        if ($scope.isJobAnalytics) {
            $scope.analytics.hires = _.chain(validRecords)
                .sortBy(function (record) { return record.hired_date || ''; })
                .map(function (record, index) {
                    return {
                        label: translate('RecruitingAnalytics.Hire') + ' ' + (index + 1),
                        days: Number(record.time_to_hire),
                        hiredDate: record.hired_date ? moment(record.hired_date).format('MMM D, YYYY') : ''
                    };
                })
                .value();
            $scope.kpis.hiresCompleted = validRecords.length;
            $scope.kpis.fastestTimeToHire = validRecords.length ?
                _.min(_.map(validRecords, function (record) { return Number(record.time_to_hire); })) : 0;
            $scope.kpis.longestTimeToHire = validRecords.length ?
                _.max(_.map(validRecords, function (record) { return Number(record.time_to_hire); })) : 0;
        }
        $scope.kpis.averageTimeToHire = validRecords.length ?
            Math.round(allHireDays / validRecords.length) : 0;
    }

    function completeRequest(generation, failed) {
        if (generation !== loadGeneration) {
            return;
        }

        $scope.pendingRequests -= 1;
        $scope.loadError = $scope.loadError || failed;
        if ($scope.pendingRequests === 0) {
            $scope.loading = false;
            $scope.lastUpdated = moment();
        }
    }

    function trackRequest(promise, generation, report, prepare) {
        $scope.reportStates[report] = { loading: true, error: false };
        promise.then(function (response) {
            if (generation === loadGeneration) {
                try {
                    prepare(response);
                } catch (error) {
                    $scope.reportStates[report] = { loading: false, error: true };
                    completeRequest(generation, true);
                    throw error;
                }
                $scope.reportStates[report] = { loading: false, error: false };
            }
            completeRequest(generation, false);
        }, function () {
            if (generation === loadGeneration) {
                $scope.reportStates[report] = { loading: false, error: true };
            }
            completeRequest(generation, true);
        });
    }

    $scope.reportFinished = function (report) {
        var state = $scope.reportStates[report];
        return state && !state.loading && !state.error;
    };

    function resetReportData() {
        $scope.analytics = {
            journey: [],
            journeySteps: [],
            sources: [],
            sourceEffectiveness: [],
            stages: [],
            jobsPosted: [],
            funnel: [],
            jobPerformance: [],
            openJobs: [],
            oldestOpenJobs: [],
            agingBuckets: [],
            hires: [],
            stageDurations: [],
            progression: []
        };
        $scope.kpis = {};
        $scope.reportStates = {};
    }

    function reportParams() {
        var isPublic = $scope.filters.jobScope === 'public';
        return {
            start_date: $scope.filters.startDate,
            end_date: $scope.filters.endDate,
            public: isPublic,
            internal: !isPublic,
            category_and: 'false',
            dates_ranges: 'active_within_date_range'
        };
    }

    function mainReportParams(report) {
        var params = $scope.isJobAnalytics ? { job_id: $scope.jobId } : reportParams();
        params[report] = true;
        return params;
    }

    $scope.setPeriod = function (days) {
        $scope.filters.startDate = moment().subtract(days - 1, 'days').startOf('day');
        $scope.filters.endDate = moment().endOf('day');
        $scope.loadReports();
    };

    $scope.isPeriod = function (days) {
        var startDate = moment($scope.filters.startDate).startOf('day');
        var endDate = moment($scope.filters.endDate).startOf('day');
        return endDate.isSame(moment().startOf('day')) &&
            startDate.isSame(moment().subtract(days - 1, 'days').startOf('day'));
    };

    $scope.toggleReport = function (report) {
        $scope.collapsedReports[report] = !$scope.collapsedReports[report];
        if (report === 'activity' && $scope.collapsedReports[report]) {
            removeJourneyTooltip();
        }
        saveCollapsedReportPreferences();
    };

    $scope.sortJobPerformance = function (field) {
        if ($scope.jobPerformanceSort.field === field) {
            $scope.jobPerformanceSort.reverse = !$scope.jobPerformanceSort.reverse;
        } else {
            $scope.jobPerformanceSort.field = field;
            $scope.jobPerformanceSort.reverse = field !== 'name';
        }
        $scope.jobPerformanceSort.predicate = field === 'averageTimeToHire' ?
            $scope.jobPerformanceSortValue : field;
    };

    $scope.jobPerformanceSortValue = function (jobPerformance) {
        var value = jobPerformance[$scope.jobPerformanceSort.field];

        if ($scope.jobPerformanceSort.field === 'averageTimeToHire' && value === null) {
            // orderBy reverses all values for descending sorts, so use the opposite sentinel in each direction.
            return $scope.jobPerformanceSort.reverse ? -Infinity : Infinity;
        }
        return value;
    };

    $scope.selectAgingBucket = function (bucket) {
        $scope.selectedAgingBucket = $scope.selectedAgingBucket === bucket ? null : bucket;
    };

    $scope.toggleAllOpenJobs = function () {
        $scope.showAllOpenJobs = !$scope.showAllOpenJobs;
    };

    $scope.printAnalytics = function () {
        var collapsedReports = angular.copy($scope.collapsedReports);

        // Collapsed report bodies are removed by ng-if, so render them before
        // the browser captures the page and restore the user's view afterward.
        _.each($scope.collapsedReports, function (collapsed, report) {
            $scope.collapsedReports[report] = false;
        });

        $timeout(function () {
            try {
                $window.print();
            } finally {
                $scope.collapsedReports = collapsedReports;
            }
        }, 100);
    };

    $scope.loadReports = function () {
        var startDate = moment($scope.filters.startDate);
        var endDate = moment($scope.filters.endDate);
        var maxEndDate = startDate.clone().startOf('day').add(maxReportRangeMonths, 'months');
        var dateRangeExceedsLimit = startDate.isValid() && endDate.isValid() &&
            endDate.clone().startOf('day').isAfter(maxEndDate);
        var generation;
        var timeParams;

        $scope.invalidDateRange = !$scope.isJobAnalytics &&
            (!startDate.isValid() || !endDate.isValid() ||
                startDate.isAfter(endDate) || dateRangeExceedsLimit);
        if ($scope.invalidDateRange) {
            return;
        }

        generation = ++loadGeneration;
        $scope.loading = true;
        $scope.loadError = false;
        removeJourneyTooltip();
        $scope.pendingRequests = $scope.isJobAnalytics ? 6 : 8;
        resetReportData();
        $scope.selectedAgingBucket = null;
        $scope.showAllOpenJobs = false;

        if ($scope.isJobAnalytics) {
            timeParams = {
                job_id: $scope.jobId,
                milestone_type: 'hired'
            };
        } else {
            timeParams = {
                milestone_type: 'hired',
                milestone_start_date: startDate.format('YYYY-MM-DD'),
                milestone_end_date: endDate.format('YYYY-MM-DD')
            };
        }

        // Request each legacy report separately so a slow or failed dataset does
        // not prevent the other dashboard cards from rendering.
        trackRequest(railApi.post('get_reports', mainReportParams('candidate_source')).promise,
            generation, 'candidateSources', function (response) {
                prepareCandidateSources(response.candidateSource || []);
            });
        trackRequest(railApi.post('get_reports', mainReportParams('job_views')).promise,
            generation, 'jobViews', function (response) {
                prepareJobViews(response.jobViews || []);
            });

        if (!$scope.isJobAnalytics) {
            trackRequest(railApi.post('get_reports', mainReportParams('jobs_posted')).promise,
                generation, 'jobsPosted', function (response) {
                    prepareJobsPosted(response.jobsPosted || []);
                });
            trackRequest(railApi.post('get_reports', mainReportParams('applicants_stage')).promise,
                generation, 'applicantStages', function (response) {
                    prepareApplicantStages(response.total || []);
                });
            trackRequest(railApi.post('get_reports', mainReportParams('source_effectiveness')).promise,
                generation, 'sourceEffectiveness', function (response) {
                    $scope.analytics.sourceEffectiveness = prepareSourceEffectiveness(response.sourceEffectiveness);
                });
        }

        // The milestone report calculates hire duration in one query. The
        // legacy location report performs an unbounded N+1 scan and times out
        // for tenants with substantial recruiting history.
        trackRequest(railApi.get('jobs/milestone_report/', timeParams).promise,
            generation, 'timeToHire', prepareTimeToHire);

        if ($scope.isJobAnalytics) {
            trackRequest(railApi.get('jobs/' + $scope.jobId).promise,
                generation, 'job', prepareJob);
            trackRequest(railApi.get('jobs/stage_duration_report', { job_id: $scope.jobId }).promise,
                generation, 'stageDurations', function (response) {
                    $scope.analytics.stageDurations = prepareStageDurations(response);
                });
            trackRequest(railApi.get('jobs/stage_progression_report', { job_id: $scope.jobId }).promise,
                generation, 'progression', function (response) {
                    $scope.analytics.progression = prepareCandidateProgression(response);
                });
        } else {
            trackRequest(railApi.get('jobs/job_performance_report', {
                start_date: startDate.format('YYYY-MM-DD'),
                end_date: endDate.format('YYYY-MM-DD'),
                public: $scope.filters.jobScope === 'public',
                internal: $scope.filters.jobScope === 'internal'
            }).promise, generation, 'jobPerformance', function (response) {
                $scope.analytics.jobPerformance = prepareJobPerformance(response);
            });

            trackRequest(railApi.get('jobs/open_job_aging_report', {
                public: $scope.filters.jobScope === 'public',
                internal: $scope.filters.jobScope === 'internal'
            }).promise, generation, 'openJobs', function (response) {
                var aging = prepareOpenJobAging(response);
                $scope.analytics.openJobs = aging.jobs;
                $scope.analytics.oldestOpenJobs = aging.oldestJobs;
                $scope.analytics.agingBuckets = aging.buckets;
            });
        }
    };

    $scope.loadReports();
};

recruitingAnalyticsCtrl.$inject = ['$scope', 'railApi', '$filter', '$stateParams', '$rootScope', '$window', '$timeout'];

module.exports = recruitingAnalyticsCtrl;
